module.exports = __webpack_public_path__ + "img/blog-16-2.5847dae7.webp";